<div class="cluster-ind1-vs-ind2-container">
	<h2 class="title-plot">{{ titleX }} vs {{titleY}}</h2>
	<div [id]="ph_id" class="cluster-ind1-vs-ind2-ph"></div>
</div>
